import type { Plugin } from "../core/plugin";
import { PluginRegistry } from "../core/pluginRegistry";

export class TktWidgetB2BPanelScrollPlugin implements Plugin {
  private content: HTMLElement | null;
  private scrollbar: HTMLElement | null;
  private resizeObserver: ResizeObserver | null = null;

  constructor(private readonly element: HTMLElement) {
    this.content = element.querySelector(".tkt-widgetB2B__panel__content");
    this.scrollbar = element.querySelector(".tkt-widgetB2B__panel__scrollbar");
  }

  init(): void {
    if (!this.content || !this.scrollbar) return;

    this.update();
    this.content.addEventListener("scroll", this.update);

    this.resizeObserver = new ResizeObserver(() => this.update());
    this.resizeObserver.observe(this.content);
    Array.from(this.content.children).forEach((child) =>
      this.resizeObserver?.observe(child),
    );
  }

  destroy(): void {
    this.content?.removeEventListener("scroll", this.update);
    this.resizeObserver?.disconnect();
    this.resizeObserver = null;
  }

  private update = (): void => {
    if (!this.content || !this.scrollbar) return;

    const { scrollHeight, clientHeight, scrollTop } = this.content;
    const hasOverflow = scrollHeight > clientHeight;
    this.scrollbar.classList.toggle("is-visible", hasOverflow);

    if (!hasOverflow) return;

    const thumbRatio = clientHeight / scrollHeight;
    const maxScrollTop = scrollHeight - clientHeight;
    const thumbTopRatio = maxScrollTop > 0 ? scrollTop / maxScrollTop : 0;

    this.scrollbar.style.setProperty("--thumb-scale", String(thumbRatio));
    this.scrollbar.style.setProperty(
      "--thumb-top",
      `${thumbTopRatio * (1 - thumbRatio) * 100}%`,
    );
  };
}

PluginRegistry.register(
  "tktWidgetB2BPanelScroll",
  TktWidgetB2BPanelScrollPlugin,
);
